import { createFileRoute } from '@tanstack/react-router'
import { CRT_ROUTES, toStaticData } from '../crt-route-config'

export const Route = createFileRoute('/_auth/_modules/crt/bpc-actuals')({
  staticData: toStaticData(CRT_ROUTES['/crt/bpc-actuals']),
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
